const UserRoles = {
    ADMIN: 1,
    REGULAR: 2,
    LMS_CONFIGURATOR: 3,
    REPORT_VIEWER: 4,
    IMPERSONATOR: 5,
    BETA_TESTER: 6,
}

export const UserTypes = {
    SYSTEM_ADMIN: 1,
    USER: 2,
    SHOP_USER: 3,
}

export const getRoleName = role => {
    const mapping = {
        [UserRoles.ADMIN]: 'Admin',
        [UserRoles.REGULAR]: 'Regular',
        [UserRoles.LMS_CONFIGURATOR]: 'LMS Configurator',
        [UserRoles.REPORT_VIEWER]: 'Report Viewer',
        [UserRoles.IMPERSONATOR]: 'Impersonator',
        [UserRoles.BETA_TESTER]: 'Beta Tester',
    }

    return mapping[role] || 'Unknown role'
}

export const getTypeName = type => {
    const mapping = {
        [UserTypes.SYSTEM_ADMIN]: 'System Admin',
        [UserTypes.USER]: 'User',
        [UserTypes.SHOP_USER]: 'Shop User',
    }

    return mapping[type] || 'Unknown type'
}

export const isOrganizationAdmin = (roles, type) => roles.includes(UserRoles.ADMIN) && type === UserTypes.USER
export const isSystemAdmin = (roles, type) => roles.includes(UserRoles.ADMIN) && type === UserTypes.SYSTEM_ADMIN
export default UserRoles
